import React from 'react';

// Thumbnail helper function ta ekhane niye eshechi
const getYouTubeThumbnail = (url) => {
  if (!url) return 'https://via.placeholder.com/640x360.png?text=Video+Thumbnail';
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11)
    ? `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`
    : 'https://via.placeholder.com/640x360.png?text=Video+Thumbnail';
};

function VideoSection({ videos, visibleVideos, loading, loadMoreVideos, setPlayingVideo }) {
  
  // MAGIC LINE: Admin panel-e drag-and-drop kora order hishebe sajiye nichchi
  const sortedVideos = [...videos].sort((a, b) => (a.display_order || 0) - (b.display_order || 0));

  return (
    <section id="videos" className="py-24 px-6 md:px-16 lg:px-24 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto">
        <header className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div>
            <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">Watch & Learn</span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-deep-charcoal mt-4">Video Resources</h2>
          </div>
        </header>
        
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-ocean-teal"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
              {/* Ekhane videos.slice er bodole sortedVideos.slice use kora holo */}
              {sortedVideos.slice(0, visibleVideos).map((video) => (
                <div 
                  key={video.id} 
                  onClick={() => setPlayingVideo(video.video_link)}
                  onKeyDown={(e) => e.key === 'Enter' && setPlayingVideo(video.video_link)}
                  tabIndex={0}
                  className="group cursor-pointer bg-white rounded-[2.5rem] p-4 shadow-sm hover:shadow-2xl transition-all duration-500 border border-transparent hover:border-gray-100 outline-none focus-visible:ring-4 focus-visible:ring-ocean-teal/20"
                >
                  <div className="relative aspect-video overflow-hidden rounded-[2rem]">
                    <img src={getYouTubeThumbnail(video.video_link)} alt={video.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" />
                    <div className="absolute inset-0 bg-deep-charcoal/20 group-hover:bg-deep-charcoal/40 transition-colors duration-500 flex items-center justify-center">
                      <div className="bg-white/90 text-ocean-teal w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transform group-hover:scale-110 transition-transform duration-300">
                        <svg className="w-6 h-6 ml-1" fill="currentColor" viewBox="0 0 20 20"><path d="M4 4l12 6-12 6z"></path></svg>
                      </div>
                    </div>
                  </div>
                  <div className="pt-6 px-3 pb-3">
                    <h3 className="text-lg font-serif font-bold leading-tight line-clamp-2 text-deep-charcoal/90 group-hover:text-ocean-teal transition-colors">{video.title}</h3>
                  </div>
                </div>
              ))}
            </div>

            {/* Load More Pagination */}
            {visibleVideos < sortedVideos.length && (
              <div className="mt-16 text-center">
                <button 
                  onClick={loadMoreVideos}
                  className="px-10 py-4 bg-transparent border-2 border-ocean-teal/30 text-ocean-teal font-black uppercase tracking-[0.2em] text-xs rounded-full hover:bg-ocean-teal hover:text-white hover:border-transparent transition-all shadow-sm focus:outline-none focus:ring-4 focus:ring-ocean-teal/20"
                >
                  Load More Content
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}

export default VideoSection;